<template lang="html">
  <div class="container-fluid __windowHeight_">
    <div class="row h-100">
       <!--
      ==================
       import sidebar
      ==================
     -->
      <Sidebar></Sidebar>
      <!--
      ==================
       dashboard page
      ==================
     -->
      <div class="col-md p-0">
        <div class="paymentstatus">
          <DetailsPayment></DetailsPayment>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/global/Sidebar.vue'
import DetailsPayment from '@/components/payment/paymentStatus/DetailsPayment.vue'
export default {
  name: 'paymentHistory',
  components: {
    Sidebar,
    DetailsPayment
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/view/paymentDetail/index.vue